import axios from "axios";

const DEFAULT_CONF = {};

const OQCalcApi = {
  getCartItem(order_item) {
    return axios
      .post(
        process.env.VUE_APP_OQ_CALC_API + "/get_cart_item",
        { order_item },
        DEFAULT_CONF
      )
      .then((r) => {
        return r.data;
      })
      .catch(() => undefined);
  },
  requestMaterials(order_item) {
    return axios
      .post(
        process.env.VUE_APP_OQ_CALC_API + "/get_available_materials",
        { order_item },
        DEFAULT_CONF
      )
      .then((r) => {
        return r.data;
      })
      .catch(() => undefined);
  },
  getRepresentationDates(order_item) {
    return axios
      .post(
        process.env.VUE_APP_OQ_CALC_API + "/get_representation_dates",
        { order_item },
        DEFAULT_CONF
      )
      .then((r) => {
        return r.data;
      })
      .catch(() => undefined);
  },
};

export default OQCalcApi;
